var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"leftCode"}},[_c('div',{staticClass:"leftCodeContainer"},[_c('ContentTop',{attrs:{"title":"运动码使用情况","type":1}}),_c('div',{staticClass:"item-chart-top"},[_c('Echart',{attrs:{"options":_vm.options,"id":"bottomLeftChart1","height":"190px","width":"100%"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }